var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66797 1.1024L15.2773 13.7493L19.5294 9.61476L5.13764 1.18846C4.65469 0.905691 4.11606 0.904946 3.66797 1.1024Z",
    fill: "#73BD70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.656 18.6256L15.2472 14.9121L3.375 26.4561C3.86563 26.8074 4.54539 26.8873 5.1406 26.5388L18.656 18.6256Z",
    fill: "#EE2243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2576 10.04L15.8281 14.347L19.3712 18.2068L24.3993 15.2628C25.4686 14.6368 25.4686 13.0911 24.3993 12.465L20.2576 10.04Z",
    fill: "#FCC53B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0295 1.60352L14.6976 14.3145L2.85202 25.8326C2.75465 25.6261 2.69922 25.3925 2.69922 25.1396V2.58732C2.69922 2.20699 2.82461 1.87029 3.0295 1.60352Z",
    fill: "#4EC7F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/google_play_icon.f1cf87d9f09cb00c7b56864ab28a7232.svg";
export { ForwardRef as ReactComponent };